import { Box, CircularProgress, SxProps, Tooltip } from "@mui/material";
import attachApi from "api/attachments";
import { CSSProperties, FunctionComponent, useEffect, useMemo, useRef, useState } from "react";
import theme from "styles/theme";
import { Attachment } from "types/Attachment";



interface Props {
    attach?: Partial<Attachment>;
    onClick?: () => void;
    sx?: SxProps;
    tooltip?: string;
}

const ImageBlobCmp: FunctionComponent<Props> = ({
    attach,
    onClick,
    sx,
    tooltip,
}) => {
    const [isVisible, setIsVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);
    const [blob, setBlob] = useState<Blob>(null);
    const imageRef = useRef<HTMLDivElement>(null);

    // useEffect(() => {
    //     const observer = new IntersectionObserver(
    //         ([entry]) => {
    //             setIsVisible(entry.isIntersecting)
    //             // if (entry.isIntersecting && !isVisible) {
    //             //     setIsVisible(true);
    //             // }
    //         },
    //         { threshold: 0.1 }
    //     )
    //     if (imageRef.current) {
    //         observer.observe(imageRef.current);
    //     }
    //     return () => {
    //         if (imageRef.current) {
    //             observer.unobserve(imageRef.current);
    //         }
    //     }
    // }, [])

    useEffect(() => {
        if (!attach) return
        if (attach.file) {
            setBlob(attach.file)
            setIsLoading(false)
            return
        }
        async function fetchBlob() {
            const blob = await attachApi.downloadThumb(attach.farmId, attach.id)
            setBlob(blob)
            setIsLoading(false)
        }
        fetchBlob()
    }, [attach]);

    const blobUrl = useMemo(() => {
        if (!blob) return null
        return URL.createObjectURL(blob);
    }, [blob]);

    const handleImageLoad = () => {
        setIsLoading(false);
        setHasError(false);
    };

    const handleImageError = () => {
        setIsLoading(false);
        setHasError(true);
    };

    return (
        <Tooltip title={tooltip}>
            <Box ref={imageRef} sx={[sxRoot, { cursor: "pointer" }, sx] as SxProps}
                onClick={onClick}
            >

                {isLoading && <CircularProgress size={25} />}

                {blobUrl && !hasError && (
                    <img
                        src={blobUrl}
                        onLoad={handleImageLoad}
                        onError={handleImageError}
                        style={styImg(isLoading)}
                        alt=""
                    />
                )}
                
            </Box>
        </Tooltip>
    );
};

export default ImageBlobCmp;

const sxRoot: SxProps = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    borderRadius: "5px",
    overflow: "hidden",
    bgcolor: "rgba(0, 0, 0, 0.2)",
};

const sxError: SxProps = {
    color: theme.palette.error.main,
    textAlign: "center",
    fontSize: 12,
    fontWeight: 500,
    p: 1,
};

const styImg = (loading: boolean): CSSProperties => ({
    display: loading ? "none" : "block",
    objectFit: "cover",
    width: "100%",
    height: "100%",
});
